var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLoadCircle = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.36413 12.3434C4.69648 13.5838 5.42883 14.6798 6.44759 15.4616C7.46635 16.2433 8.71458 16.667 9.9987 16.667C11.2828 16.667 12.531 16.2433 13.5498 15.4616C14.5686 14.6798 15.3009 13.5838 15.6333 12.3434",
    stroke: "#8F27C7",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.9987 10.833L9.374 11.6139L9.9987 12.1136L10.6234 11.6139L9.9987 10.833ZM10.9987 3.33301C10.9987 2.78072 10.551 2.33301 9.9987 2.33301C9.44641 2.33301 8.9987 2.78072 8.9987 3.33301L10.9987 3.33301ZM5.20734 8.28054L9.374 11.6139L10.6234 10.0521L6.45673 6.71881L5.20734 8.28054ZM10.6234 11.6139L14.7901 8.28054L13.5407 6.71881L9.374 10.0521L10.6234 11.6139ZM10.9987 10.833L10.9987 3.33301L8.9987 3.33301L8.9987 10.833L10.9987 10.833Z",
    fill: "#8F27C7"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLoadCircle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/LoadCircle.68b1214be3dfcef68cf8b0faa90350e8.svg";